export const formatNumberWithCommas = (num?: number): string => {
  return (num ?? 0).toLocaleString('en-US', {
    style: 'decimal',
    useGrouping: true,
  })
}
